import { Component } from '@angular/core';
import { MenuStateService } from '../../services/menu-state.service';

@Component({
  selector: 'app-menu-novedades',
  standalone: false,
  templateUrl: './menu-novedades.component.html',
  styleUrl: './menu-novedades.component.css'
})
export class MenuNovedadesComponent {
  constructor(private menuStateService: MenuStateService) {
  }
  
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
}
